import {from} from 'rxjs';

import {getApolloClient} from 'web-app/api/clients/famly-app';

import * as Queries from './note-modal/queries';

export const deleteNoteObservable = (noteId: string) =>
    from(
        getApolloClient().mutate({
            mutation: Queries.DeleteNoteQuery,
            variables: {noteId},
        }),
    );
